import axios from 'axios';
import ConfigAxios from './ConfigAxios';

const getAllUsers = () => {
  let {NERTHUS, options} = ConfigAxios();
  return axios.get(NERTHUS + '/users', options);
};

const getUserById = dataUserId => {
  let {NERTHUS, options} = ConfigAxios();
  return axios.get(NERTHUS + '/users/code/' + dataUserId, options);
};

const createUser = dataUser => {
  let {NERTHUS, options} = ConfigAxios();
  return axios.post(NERTHUS + '/users', dataUser, options);
};

const updateUser = (dataUser, dataUserId) => {
  let {NERTHUS, options} = ConfigAxios();
  return axios.put(NERTHUS + '/users/code/' + dataUserId, dataUser, options);
};

const deleteUser = dataUserId => {
  let {NERTHUS, options} = ConfigAxios();
  return axios.delete(NERTHUS + '/users/code/' + dataUserId, options);
};

const UserCrudService = {
  getAllUsers,
  getUserById,
  createUser,
  updateUser,
  deleteUser
};

export default UserCrudService;